import { render, staticRenderFns } from "./CommerceDebutGuide.vue?vue&type=template&id=537a21ea&scoped=true"
import script from "./CommerceDebutGuide.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommerceDebutGuide.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CommerceDebutGuide.vue?vue&type=style&index=0&id=537a21ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537a21ea",
  null
  
)

export default component.exports